import { useNotif } from '@/common/notif/NotifContext';
import { NotifMenu } from '@/common/notif/NotifMenu';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@mui/material';
import { useState } from 'react';
import { SideNavButton } from './SideNavButton';

export const NotifButton = () => {

  const { notifCount } = useNotif();

  const [anchorEl, setAnchorEl] = useState(null);

  // When the ProfileButton is clicked, set the anchor element
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the ProfileMenu by clearing the anchor
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SideNavButton
        dataTestId="sidenav-notif-button"
        onClick={handleClick}
        tooltip="Notifications"
        icon={
          <Badge badgeContent={notifCount} color="primary">
            <FontAwesomeIcon icon={fas.faBell} size="2x" />
          </Badge>
        }
      />
      <NotifMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      />
    </>
  )
}